import { createReducer, on } from '@ngrx/store';

import {
  clearWebState,
  loadExtras,
  loadExtrasFailure,
  loadExtrasSuccess,
  loadFilters,
  loadFiltersFailure,
  loadFiltersSuccess,
  loadLocationAutoComplete,
  loadLocationAutoCompleteFailure,
  loadLocationAutoCompleteSuccess,
  setCarDetail,
  setLocationDetail,
} from './web.actions';
import { INITIAL_WEB_STATE } from './web.state';

export const webReducer = createReducer(
  INITIAL_WEB_STATE,

  // car detail
  on(setCarDetail, (state, { carDetail }) => ({ ...state, carDetail })),

  // location detail
  on(setLocationDetail, (state, { locationDetail }) => ({
    ...state,
    locationDetail,
  })),

  // location autocomplete
  on(loadLocationAutoComplete, (state) => ({
    ...state,
    isSearchingLocation: true,
    locationAutoCompleteList: [],
  })),

  on(loadLocationAutoCompleteSuccess, (state, { list }) => ({
    ...state,
    isSearchingLocation: false,
    locationAutoCompleteList: list,
  })),

  on(loadLocationAutoCompleteFailure, (state) => ({
    ...state,
    isSearchingLocation: false,
    locationAutoCompleteList: [],
  })),

  // filters loading
  on(loadFilters, (state) => ({
    ...state,
    error: null,
  })),
  on(loadFiltersSuccess, (state, { filters }) => ({
    ...state,
    filters,
  })),
  on(loadFiltersFailure, (state, { error }) => ({
    ...state,
    error,
  })),

  // extras
  on(loadExtras, (state) => ({
    ...state,
    extrasLoading: true,
    extrasError: null,
  })),

  on(loadExtrasSuccess, (state, { extras }) => ({
    ...state,
    extras,
    extrasLoading: false,
  })),

  on(loadExtrasFailure, (state, { error }) => ({
    ...state,
    extrasLoading: false,
    extrasError: error,
  })),

  // clear state
  on(clearWebState, (state) => ({
    ...INITIAL_WEB_STATE,
    filters: state.filters,
    extras: state.extras,
    locationAutoCompleteList: state.locationAutoCompleteList,
  }))
);
